import { useState } from "react"
import { useCookies } from "react-cookie"
import PrefsButton from "./PrefsButton"
import PrefsModal from "./PrefsModal"

function PrefsHandler({ userPrefs, setUserPrefs }) {
    const [ active, setActive ] = useState(false)

    const handleOpen = async (e) => {
        e.preventDefault()
        setActive(true)
    }

    const handleClose = async (e) => {
        e.preventDefault()
        setActive(false)
    }

    return <>{
        active
            ? <PrefsModal 
                closeHandler={handleClose}
                userPrefs={userPrefs}
                setUserPrefs={setUserPrefs} 
            />
            : null
    }
    <PrefsButton clickHandler={handleOpen} />
    </>
}

export default PrefsHandler